export class LanguageService {
  static key = 'lang';
  public static setLanguage(lang: string): void {
    sessionStorage.setItem(this.key, lang);
  }
  public static getLanguage(): string {
    return sessionStorage.getItem(this.key) || 'th';
  }
}
